import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Store } from '@ngxs/store';

import { validateColorContrast } from '@plugins/client/colors/color-utils';
import { StatusLabels } from '@plugins/faq-lib/types';

import { DECORATIVE_CONTRAST_TOKEN } from '../../../app.module';
import { STATUS_COLOR } from '../../models/status.model';
import { InstanceState } from '../../store/instance/instance.state';

@Component({
  selector: 'faq-question-status',
  standalone: false,
  templateUrl: './question-status.component.html',
  styleUrl: './question-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionStatusComponent {
  readonly statusType = input.required<StatusLabels>();

  readonly store = inject(Store);
  readonly contrastRatio = inject(DECORATIVE_CONTRAST_TOKEN);

  readonly instance = this.store.selectSignal(InstanceState.instance);

  readonly color = computed(() => {
    const selector = STATUS_COLOR[this.statusType()];
    return validateColorContrast(
      this.instance().settings[selector],
      this.contrastRatio,
    );
  });
}
